<template>
  <div class="attachment-storage-container">
    <div class="attachment-storage-content">
      <div class="attachment-storage-header">
        <h2>存储设置</h2>
        <p>配置文件存储方式</p>
      </div>
      
      <el-form :model="form" label-width="140px">
        <el-form-item label="存储方式">
          <el-radio-group v-model="form.storageType">
            <el-radio label="local">本地存储</el-radio>
            <el-radio label="qiniu">七牛云存储</el-radio>
            <el-radio label="aliyun">阿里云存储</el-radio>
            <el-radio label="tencent">腾讯云存储</el-radio>
          </el-radio-group>
        </el-form-item>
        
        <!-- 本地存储设置 -->
        <div v-if="form.storageType === 'local'" class="storage-config">
          <div class="config-title">本地存储设置</div>
          <el-form-item label="存储路径">
            <el-input v-model="form.local.path" placeholder="请输入存储路径"></el-input>
          </el-form-item>
          <el-form-item label="访问URL">
            <el-input v-model="form.local.url" placeholder="请输入访问URL"></el-input>
          </el-form-item>
          <el-form-item label="文件保存时长">
            <el-input-number v-model="form.local.expireTime" :min="1" :max="24" :step="1" placeholder="请输入保存时长(小时)"></el-input-number>
            <span style="margin-left: 10px;">小时</span>
          </el-form-item>
          <el-form-item label="自动清理">
            <el-switch v-model="form.local.autoClean" active-text="启用" inactive-text="禁用"></el-switch>
          </el-form-item>
        </div>
        
        <!-- 七牛云存储设置 -->
        <div v-if="form.storageType === 'qiniu'" class="storage-config">
          <div class="config-title">七牛云存储设置</div>
          <el-form-item label="Access Key">
            <el-input v-model="form.qiniu.accessKey" placeholder="请输入Access Key"></el-input>
          </el-form-item>
          <el-form-item label="Secret Key">
            <el-input v-model="form.qiniu.secretKey" placeholder="请输入Secret Key"></el-input>
          </el-form-item>
          <el-form-item label="存储空间">
            <el-input v-model="form.qiniu.bucket" placeholder="请输入存储空间名称"></el-input>
          </el-form-item>
          <el-form-item label="访问域名">
            <el-input v-model="form.qiniu.domain" placeholder="请输入访问域名"></el-input>
          </el-form-item>
        </div>
        
        <!-- 阿里云存储设置 -->
        <div v-if="form.storageType === 'aliyun'" class="storage-config">
          <div class="config-title">阿里云存储设置</div>
          <el-form-item label="Access Key ID">
            <el-input v-model="form.aliyun.accessKeyId" placeholder="请输入Access Key ID"></el-input>
          </el-form-item>
          <el-form-item label="Access Secret">
            <el-input v-model="form.aliyun.accessKeySecret" placeholder="请输入Access Secret"></el-input>
          </el-form-item>
          <el-form-item label="Bucket">
            <el-input v-model="form.aliyun.bucket" placeholder="请输入Bucket名称"></el-input>
          </el-form-item>
          <el-form-item label="地域">
            <el-input v-model="form.aliyun.region" placeholder="请输入地域"></el-input>
          </el-form-item>
          <el-form-item label="访问域名">
            <el-input v-model="form.aliyun.domain" placeholder="请输入访问域名"></el-input>
          </el-form-item>
        </div>
        
        <!-- 腾讯云存储设置 -->
        <div v-if="form.storageType === 'tencent'" class="storage-config">
          <div class="config-title">腾讯云存储设置</div>
          <el-form-item label="APPID">
            <el-input v-model="form.tencent.appId" placeholder="请输入APPID"></el-input>
          </el-form-item>
          <el-form-item label="SecretID">
            <el-input v-model="form.tencent.secretId" placeholder="请输入SecretID"></el-input>
          </el-form-item>
          <el-form-item label="SecretKey">
            <el-input v-model="form.tencent.secretKey" placeholder="请输入SecretKey"></el-input>
          </el-form-item>
          <el-form-item label="Bucket">
            <el-input v-model="form.tencent.bucket" placeholder="请输入Bucket名称"></el-input>
          </el-form-item>
          <el-form-item label="地区">
            <el-select v-model="form.tencent.region" placeholder="请选择地区">
              <el-option label="北京一区（已售罄）" value="ap-beijing-1"></el-option>
              <el-option label="北京二区" value="ap-beijing-2"></el-option>
              <el-option label="上海" value="ap-shanghai"></el-option>
              <el-option label="广州" value="ap-guangzhou"></el-option>
              <el-option label="深圳" value="ap-shenzhen-fsi"></el-option>
              <el-option label="成都" value="ap-chengdu"></el-option>
              <el-option label="重庆" value="ap-chongqing"></el-option>
              <el-option label="香港" value="ap-hongkong"></el-option>
              <el-option label="新加坡" value="ap-singapore"></el-option>
              <el-option label="首尔" value="ap-seoul"></el-option>
              <el-option label="东京" value="ap-tokyo"></el-option>
              <el-option label="法兰克福" value="eu-frankfurt"></el-option>
              <el-option label="孟买" value="ap-mumbai"></el-option>
              <el-option label="硅谷" value="na-siliconvalley"></el-option>
              <el-option label="弗吉尼亚" value="na-ashburn"></el-option>
              <el-option label="多伦多" value="na-toronto"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="访问域名">
            <el-input v-model="form.tencent.url" placeholder="请输入访问域名"></el-input>
          </el-form-item>
        </div>
        
        <el-form-item>
          <el-button type="primary" @click="saveSettings">保存设置</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'AttachmentStorage',
  data() {
    return {
      form: {
        storageType: 'local',
        local: {
          path: './uploads',
          url: '/uploads',
          expireTime: 1,
          autoClean: true
        },
        qiniu: {
          accessKey: '',
          secretKey: '',
          bucket: '',
          domain: ''
        },
        aliyun: {
          accessKeyId: '',
          accessKeySecret: '',
          bucket: '',
          region: '',
          domain: ''
        },
        tencent: {
          appId: '',
          secretId: '',
          secretKey: '',
          bucket: '',
          region: '',
          url: ''
        }
      },
      loading: false
    }
  },
  mounted() {
    // 初始化获取设置
    this.initSettings()
  },
  methods: {
    async initSettings() {
      try {
        const response = await axios.get('/admin/attachment-setting')
        this.form = response.data
      } catch (error) {
        this.$message.error('获取设置失败，请稍后重试')
      }
    },
    async saveSettings() {
      this.loading = true
      try {
        console.log('发送的数据:', this.form)
        const response = await axios.put('/admin/attachment-setting', this.form)
        console.log('响应结果:', response.data)
        this.$message.success('设置保存成功')
      } catch (error) {
        console.error('保存失败:', error)
        console.error('错误详情:', error.response?.data || error.message)
        this.$message.error('保存设置失败: ' + (error.response?.data?.detail || error.message || '请稍后重试'))
      } finally {
        this.loading = false
      }
    },
    resetForm() {
      // 重置表单
      this.initSettings()
      this.$message.info('表单已重置')
    }
  }
}
</script>

<style scoped>
.attachment-storage-container {
  padding: 20px 0;
}

.attachment-storage-content {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  color: #333;
}

.attachment-storage-header {
  margin-bottom: 30px;
}

.attachment-storage-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.attachment-storage-header p {
  font-size: 14px;
  color: #666;
  margin: 0;
}

.storage-config {
  margin-top: 20px;
  padding: 20px;
  background: #f9f9f9;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.config-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
}
</style>
